module.exports = __webpack_public_path__ + "6b15ad541c1b6fbba10ef5a09ec20d42.jpg";